import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('batteryFormFields');

    return {
        BATTERY_NAME_FIELD_PLACEHOLDER: t('batteryNameFieldPlaceholder'),
        SERIAL_NUMBER_FIELD_PLACEHOLDER: t('serialNumberFieldPlaceholder')
    };
};

export default useTranslation;
